import { useFeatureFlagValueBool } from "./useFeatureFlagValue";

export const useConversationComponent = () => {
  return useFeatureFlagValueBool("dash_2025_02_11_conversation_assistant");
};
